export default {
      id: "icon-coeur-dans-oeil-usage",
      viewBox: "0 0 148.7 109.1",
      url: __webpack_public_path__ + "icons.svg#icon-coeur-dans-oeil",
      toString: function () {
        return this.url;
      }
    }